import React, { useContext, useEffect, useState } from "react";
import Row from "../row";
import NotificationItem from "../notifications/notification-icon";
import meApi from "../../lib/users/me-api";
import SearchBar from "./searchbar";

export const MessagesItem = () => {
    const [ unreadMessages, setUnreadMessages ] = useState(0);

    useEffect(() => {
        meApi.getConversations({ with_unread_messages: 1 }).then(({ data }) => {
            setUnreadMessages(data?.length);
        })
    }, []);

    return (
        <div className="topbar-menu__icon" onClick={() => window.location.href = '/mydmc/messages'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20.5" viewBox="0 0 21 20.5">
                <path id="Path_303" data-name="Path 303" d="M5.455,15,1,18.5V3A1,1,0,0,1,2,2H17a1,1,0,0,1,1,1V15Zm-.692-2H16V4H3V14.385ZM8,17H18.237L20,18.385V8h1a1,1,0,0,1,1,1V22.5L17.545,19H9a1,1,0,0,1-1-1Z" transform="translate(-1 -2)" fill="#fff"/>
            </svg>
            { unreadMessages > 0 && <div style={{
                position: 'absolute',
                top: '-5px',
                right: '-5px',
                width: '25px',
                height: '25px',
                background: '#1577EA',
                borderRadius: '50%',
                color: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                { unreadMessages }
            </div> }
        </div>
    )
}

class TopBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            count : {},
            unreadMessages: 5,
        }
    }

    componentDidMount() {
  
    }

    render() {
        return (
            <div className="topbar">
                <div className="topbar__content">
                    <div className="topbar__left">
                        <SearchBar />
                    </div>
                    <div className="topbar__right">
                        <Row gap="15px">
                            <MessagesItem/>
                            <NotificationItem/>
                        </Row>
                    </div>
                </div>
            </div>
        )
    }


}

export default TopBar;

